/*
 * Copyright (c) 2021.  Blacksheepz media B.V.
 * https://www.blacksheepz-media.com
 * Ramon van Ophuizen
 */

import React from 'react'
import { withTranslation } from 'react-i18next';

function Logout(props) {
    localStorage.clear();
}

export default React.memo(withTranslation('message')(Logout));
